import { render, staticRenderFns } from "./standardList.vue?vue&type=template&id=3e3f3ee0&scoped=true"
import script from "./standardList.vue?vue&type=script&lang=js"
export * from "./standardList.vue?vue&type=script&lang=js"
import style0 from "./standardList.vue?vue&type=style&index=0&id=3e3f3ee0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f3ee0",
  null
  
)

export default component.exports